<template lang="pug">
	div
		a(@click="openOrder") {{ linkText }}

		md-dialog.report(:md-active.sync="showOrderDetail", v-if="showOrderDetail")
			md-dialog-actions
				md-button.md-primary(@click="showOrderDetail = false")
					span.fa.fa-times
			md-dialog-title
				| Order # {{ order.orderId }} - {{ orderDate }}
			md-dialog-content
				hr

				h4: b Order Items

				invoice-detail(:products="order.items",
				:subtotal="subtotal",
				:taxAmount="taxAmount",
				:total="total")

				p
					h4: b Customer information

				contacts-block(:contacts="contacts")

				h4: b Payment Method

				credit-card(:card="card")

				hr
</template>

<script>
import Vue from 'vue'
import _ from 'lodash'
import moment from 'moment'
import { calcOrderTotals } from 'CommonApp/e24-services/order-totals-util'

export default {
	name: 'order-detail-popup',
	props: ['linkText', 'projId'],
	data () {
		return {
			showOrderDetail: false,
			order: null,
			card: null,
			contacts: [],
			orderDate: ''
		}
	},
	methods: {
		openOrder () {
			this.contacts = []
			// Find order and update
			Vue.e24.orderService.findOrderByProjId(this.projId).then((orderFound) => {
				if (!_.isNil(orderFound)) {
					this.order = orderFound
					this.orderDate = moment(this.order.dateCreated).format('YYYY-MM-DD HH:MM')

					Vue.e24.contactService.findContactByProjIdAndType(orderFound.projId, 'BO').then((billingContact) => {
						this.contacts.push({title: 'Billing contact', object: billingContact})

						// For display prurpouses only
						this.card = {
							nameOnCard: orderFound.payment.payorName,
							cardNumber: orderFound.payment.number,
							expireMonth: moment(orderFound.payment.expire).format('MM'),
							expireYear: moment(orderFound.payment.expire).format('YY')
						}
						this.showOrderDetail = true
					})
				} else {
					// Show order not found error
					this.$notify({
						group: 'app',
						type: 'error',
						title: 'Order not found',
						text: 'Order not found for project ' + this.projId,
						duration: -1
					})
				}
			})
		}
	},
	computed: {
		orderTotals () {
			return calcOrderTotals(this.order.orderSubtotal, this.order.orderTax)
		},
		subtotal () {
			return this.orderTotals.subtotal
		},
		taxAmount () {
			return this.orderTotals.taxAmount
		},
		total () {
			return this.orderTotals.total
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/common/components/order-detail-popup.vue